<template>
    <div>
        <div v-if="user">
            <div class="dashboard"> 
                <div class="div-align">
                    <o-card :title="$t('core.start')">
                        <p>{{$t('sandoz.tracking_info')}}</p> 
                        <template v-for="(item) in navItems"> 
                            <template v-if="!item.children">
                                <div v-if="hasPermission(item.requiredPermissions)">
                                        <fa :icon="item.icon" class="w-15em" v-if="item.icon"/>
                                        <router-link :to="{ name: item.target }" :class="item.icon !== null && item.icon !== undefined  ? '' : 'ml-28'">{{$t(item.title)}}</router-link>
                                </div>
                            </template>
                        </template>
                    </o-card>
                </div>

                <template v-for="(item) in navItems" > 
                    <template v-if="'children' in item">
                        <div class="div-align" v-if="hasVisibleChildren(item)">
                            <o-card :title="$t(item.title)">
                                <p>{{$t(item.description)}}</p>
                                <template v-for="(child) in item.children"> 
                                    <div v-if="hasPermission(child.requiredPermissions)">
                                            <fa :icon="child.icon" class="w-15em"  v-if="child.icon"/>
                                            <router-link :class="child.icon !== null && child.icon !== undefined  ? '' : 'ml-28'"  :to="{ name: child.target }">{{$t(child.title)}}</router-link>
                                    </div>
                                </template>
                            </o-card>
                        </div>
                    </template>
                </template>
              </div>
        </div>
        <div class="mt-1 col-lg-6 m-auto" v-else>
            <o-card :title="$t('core.home')">
                {{ $t('core.welcome') }}
            </o-card>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        user: 'auth/user',
        navItems: 'navigation/navItems',
      })
    },
    methods: {
			hasVisibleChildren(item) {
				var user = this.$store.getters['auth/user']
				if (!('children' in item)) {
						return false
				} else {
						if (user.is_super_user && item.children.length > 0) {
							return true
						} else {
						for (var i = 0; i < item.children.length; i++) {
							if (this.hasPermission(item.children[i].requiredPermissions)) {
								return true
							}
						}
							return false
						}
				}
			},
      hasPermission(item) {
        let result = true
        let permissions = item
        let user = this.user
        if (!user.is_super_user && permissions) {
          permissions.forEach((permission) => {
            if (!user.routePermissions.includes(permission)) {
              result = false
            }
          })
        }
        return result
      }
    }
  }
</script>

<style scoped>
.ml-28 {
    margin-left: 28px!important;
}
.col-3 {
    margin-bottom: 25px;
}
</style>
